import { cloneDeep } from 'lodash'
import useMaterialExpand from '@/components/common/PurchaseListComponent/useMaterialExpand'

/**
 * 批量处理谈判中用于采购单的品目列表
 * @param data
 * @returns {*}
 */
const batchOrderPostData = data => {
  const _data = cloneDeep(data)
  _data.orderList = (data.orderList || []).map(order => {
    order.itemList = (order.itemList || []).map(item =>
      useMaterialExpand().expandToOtherMap(item)
    )
    return order
  })
  return _data
}

/**
 * 批量获取谈判中采购单中的品目列表
 * @param data
 */
const batchOrderResData = data => {
  const _data = cloneDeep(data)
  _data.orderList = (data.orderList || []).map(order => {
    order.itemList = (order.itemList || []).map(item =>
      useMaterialExpand().otherMapToExpand(item)
    )
    return order
  })
  return _data
}

/**
 * 处理谈判中发送的品目列表
 * @param data
 * @returns {*}
 */
const changeOrderPostData = data => {
  const _data = cloneDeep(data)
  _data.itemList = (data.itemList || []).map(item =>
    useMaterialExpand().expandToOtherMap(item)
  )
  return _data
}

/**
 * 处理谈判中接收的品目列表
 * @param data
 * @returns {*}
 */
const changeOrderResData = data => {
  const _data = cloneDeep(data)
  _data.itemList = (data.itemList || []).map(item =>
    useMaterialExpand().otherMapToExpand(item)
  )
  return _data
}

/**
 * 修改供应商报价数据
 * @param data
 * @returns {*}
 */
const changeSupplierOrderPostData = data => {
  const _data = cloneDeep(data)
  _data.itemOfferList = (_data.itemOfferList || []).map(item =>
    useMaterialExpand().expandToOtherMap(
      item,
      'offerExpand',
      'otherOfferExpand'
    )
  )
  return _data
}

/**
 * 获取供应商报价数据
 * @param data
 * @returns {*}
 */
const changeSupplierOrderResData = data => {
  const _data = cloneDeep(data)
  _data.itemOfferDetailList = (data.itemOfferDetailList || []).map(item => {
    item.itemInfo = useMaterialExpand().otherMapToExpand(item.itemInfo)
    item.itemOffer = useMaterialExpand().otherMapToExpand(
      item.itemOffer,
      'otherOfferExpand'
    )
    return item
  })
  return _data
}

/**
 * 处理采购人全选比价数据
 * @param data
 */
const changeCompareAllResData = data => {
  const _data = cloneDeep(data)
  _data.recordList = (data.recordList || []).map(item =>
    useMaterialExpand().otherMapToExpand(item)
  )
  return _data
}

/**
 * 处理候选数据
 * @param data
 * @returns {*}
 */
const changeCandidateResData = data => {
  const _data = cloneDeep(data)
  _data.awardList = (data.awardList || []).map(item => {
    item.item = useMaterialExpand().otherMapToExpand(item.item)
    item.awardList = (item.awardList || []).map(awardItem => {
      return useMaterialExpand().otherMapToExpand(awardItem, 'otherOfferExpand')
    })
    return item
  })
  return _data
}

const changeCandidateCompareResData = data => {
  const _data = cloneDeep(data)
  _data.itemCompareList = (data.itemCompareList || []).map(item => {
    item.materiel = useMaterialExpand().otherMapToExpand(item.materiel)
    item.supplierCompare = useMaterialExpand().otherMapToExpand(
      item.supplierCompare,
      'otherOfferExpand'
    )
    return item
  })
  _data.awardList = (data.awardList || []).map(item => {
    item.item = useMaterialExpand().otherMapToExpand(item.item)
    item.itemOffer = useMaterialExpand().otherMapToExpand(
      item.itemOffer,
      'otherOfferExpand'
    )
    return item
  })
  return _data
}

const useMaterialNegotiation = () => {
  return {
    batchOrderPostData,
    batchOrderResData,
    changeOrderPostData,
    changeOrderResData,
    changeSupplierOrderPostData,
    changeSupplierOrderResData,
    changeCompareAllResData,
    changeCandidateResData,
    changeCandidateCompareResData
  }
}

export default useMaterialNegotiation
